import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import SkeletonGoogleAdPreviewCard from '../GoogleAdPreviewCard/Skeleton'
import GoogleAssetsSliderPreview from '../../../../../../forms/Google/AdForms/GoogleAssetsSliderPreview'
import InternalAdActionButtons from '../../../InternalAdActionButtons'
import AdCardDetails from '../../../../../../features/components/AdCardListItem/AdCardDetails'

import { getAssetGroupTransformedValues } from '../../../../../../forms/Google/AdForms/GoogleAssetGroup/GoogleAssetGroupEdit/helpers'
import useInternalAdSelfAccountName from '../../../../../../features/hooks/internalAdHooks/useInternalAdSelfAccountName'
import { useClearApproveInternalAssetGroup } from '../../../hooks'

import { openForm } from '../../../../../../modules/actions/forms'
import { approveInternalAssetGroup } from '../../../../../../modules/actions/assets'
import {
  approveInternalAssetGroupIsLoadingSelector,
  disapproveInternalAssetGroupIsLoadingSelector
} from '../../../../../../modules/selectors/assets'

import { ASSET_GROUP_GOOGLE_ADS_EDIT } from '../../../../../../constants/forms'

import useStyles from '../../../../../../styles/common/adPreviewCard'

// this component currently support only ad approvals page style
const GoogleAssetGroupPreviewCard = ({ assetGroup, disapproveInternalAssetGroupHandler }) => {
  const classes = useStyles()

  const dispatch = useDispatch()

  const adSelfAccountName = useInternalAdSelfAccountName(assetGroup)

  const { id: assetGroupId, name: assetGroupName } = assetGroup

  const assetGroupIsApproving = useSelector(approveInternalAssetGroupIsLoadingSelector(assetGroupId))
  const assetGroupIsDisapproving = useSelector(disapproveInternalAssetGroupIsLoadingSelector(assetGroupId))
  useClearApproveInternalAssetGroup(assetGroupId)

  const transformedAssetGroupValues = useMemo(() => getAssetGroupTransformedValues(assetGroup), [assetGroup])

  const approveInternalAssetGroupHandler = useCallback(() => {
    dispatch(approveInternalAssetGroup(assetGroupId))
  }, [dispatch, assetGroupId])

  const editInternalAssetGroupHandler = useCallback(() => {
    dispatch(openForm({ id: assetGroupId, formName: ASSET_GROUP_GOOGLE_ADS_EDIT, otherParams: 'internal=true' }))
  }, [dispatch, assetGroupId])

  if (assetGroupIsApproving || assetGroupIsDisapproving) {
    return <SkeletonGoogleAdPreviewCard />
  }

  return (
    <div className={classes.cardListItem}>
      <div className={classes.cardSliderPreviewWrapper}>
        <GoogleAssetsSliderPreview values={transformedAssetGroupValues} />
      </div>
      <AdCardDetails title={assetGroupName} subTitle={adSelfAccountName} />
      <InternalAdActionButtons
        approveInternalAdHandler={approveInternalAssetGroupHandler}
        editInternalAdHandler={editInternalAssetGroupHandler}
        disapproveInternalAdHandler={disapproveInternalAssetGroupHandler}
      />
    </div>
  )
}

export default GoogleAssetGroupPreviewCard
